import { default as axios } from "axios";
import {StatusCodes} from "http-status-codes";
import { withSocialChannelHeaders } from "./social-auth/social-channel";
import { useIsSocialMode } from "./social-auth/social-mode-context";

export function useBaseApi() {
    const isSocialMode = useIsSocialMode();
    const domain = process.env.API;
    const prefix = "/api";
    const token = "";
    const limitPerPage = process.env.PAGINATION;

    const requestHeaders = (headers) => withSocialChannelHeaders(headers, isSocialMode);

    const get = async (urld, auth = true, token) => {
        let url = (auth) ? domain + prefix + urld : domain + urld;
        let headers = (auth) ? {"Content-Type": "application/json", "Authorization": "Bearer " + token} : {"Content-Type": "application/json"};

        try {
            return await axios.get(url, {
                headers: requestHeaders(headers),
            });
        } catch (error) {
            if(error.response.status === StatusCodes.UNAUTHORIZED){
                logoutUser();
            }
        }
    }

    const post = async (urld, body, auth = true, contentType="application/json", token) => {

        let url = (auth) ? domain + prefix + urld : domain + urld;
        let headers = (auth) ? {"Content-Type": contentType, "Authorization": "Bearer " + token} : {"Content-Type": contentType};

        try {
            return await axios.post(url, body, {
                headers: requestHeaders(headers),
            });
        } catch (error) {
            if(error.response.status === StatusCodes.UNAUTHORIZED){
                logoutUser();
            }
        }
    }

    const put = async (urld, body, auth = true, contentType="application/json") => {

        let url = (auth) ? domain + prefix + urld : domain + urld;
        let headers = (auth) ? {"Content-Type": contentType, "Authorization": "Bearer " + token} : {"Content-Type": contentType};

        try {
            return await axios.put(url, body, {
                headers: requestHeaders(headers),
            });
        } catch (error) {
            if(error.response.status === StatusCodes.UNAUTHORIZED){
                logoutUser();
            }
        }
    }

    const searchCustom = async ({urld, filters, order = null, orderBy = null, type = "AND", auth = true, page = null}) => {
        let url = (auth) ? domain + prefix + urld : domain + urld;
        let headers = (auth) ? {"Content-Type": "application/json", "Authorization": "Bearer " + token} : {"Content-Type": "application/json"};

        if (filters) {
            let parameters = "";

            filters.forEach(function (value, i) {

                let fieldStr = "filters[" + i + "][field]=" + value.field;
                let operatorStr = "filters[" + i + "][operator]=" + value.operator;

                let valueStr = "";
                if (value.operator === "IN") {
                    value.value.forEach(function (v, c) {
                        valueStr += "filters[" + i + "][value][" + c + "]=" + v + "&";
                    });
                } else {
                    valueStr = "filters[" + i + "][value]=" + value.value + "&";
                }

                parameters += fieldStr + "&" + operatorStr + "&" + valueStr;
            });

            parameters = parameters.slice(0, -1);

            url += "?" + parameters;
        }

        //!filters ? url += "?" : url += "&";
        //url += "query_type=" + type;

        if (order && orderBy) {
            url += "&order=" + order + "&order_by=" + orderBy;
        }

        if (page !== null) {
            let offset = (page - 1) * limitPerPage;
            url += "&limit=" + limitPerPage + "&offset=" + offset;
        }

        try {
            return await axios.get(url, {
                headers: requestHeaders(headers)
            });
        } catch (error) {
            if(error.response.status === StatusCodes.UNAUTHORIZED){
                logoutUser();
            }
        }
    }
    const search = async (urld, filters, order = null, orderBy = null, type = "AND", auth = true) => {

        let url = (auth) ? domain + prefix + urld : domain + urld;
        let headers = (auth) ? {"Content-Type": "application/json", "Authorization": "Bearer " + token} : {"Content-Type": "application/json"};

        if (filters) {
            let parameters = "";

            filters.forEach(function (value, i) {

                let fieldStr = "filters[" + i + "][field]=" + value.field;
                let operatorStr = "filters[" + i + "][operator]=" + value.operator;

                let valueStr = "";
                if (value.operator === "IN") {
                    value.value.forEach(function (v, c) {
                        valueStr += "filters[" + i + "][value][" + c + "]=" + v + "&";
                    });
                } else {
                    valueStr = "filters[" + i + "][value]=" + value.value + "&";
                }

                parameters += fieldStr + "&" + operatorStr + "&" + valueStr;
            });

            parameters = parameters.slice(0, -1);

            url += "?" + parameters;
        }

        //!filters ? url += "?" : url += "&";
        //url += "query_type=" + type;

        if (order && orderBy) {
            url += "&order=" + order + "&order_by=" + orderBy;
        }

        try {
            return await axios.get(url, {
                headers: requestHeaders(headers)
            });
        } catch (error) {
            if(error.response.status === StatusCodes.UNAUTHORIZED){
                logoutUser();
            }
        }
    }

    const logoutUser = () => {

    }

    return {get, post, search, put, searchCustom};
}